export type MediaDisplayQuality = 'high' | 'medium';

export const MEDIA_DISPLAY_QUALITY_CHANGED_CHANNEL = 'radish:media-display-quality:changed';

const MEDIA_DISPLAY_QUALITY_KEY = 'radish-media-display-quality';

let _quality: MediaDisplayQuality =
  localStorage.getItem(MEDIA_DISPLAY_QUALITY_KEY) === 'medium' ? 'medium' : 'high';

export function getMediaDisplayQuality(): MediaDisplayQuality {
  return _quality;
}

export function setMediaDisplayQuality(quality: MediaDisplayQuality): void {
  _quality = quality;
  localStorage.setItem(MEDIA_DISPLAY_QUALITY_KEY, quality);
}
